import React from 'react';
import { BsEye } from 'react-icons/bs';
import { MdSchedule } from 'react-icons/md';
import { AiOutlineDelete } from 'react-icons/ai';
import './cancelledmeetings.css'
import { Cuurent_EMAIL, getEmailClassification } from '../../../../CommonCase/CommonFunctions';
import { use } from 'react';
import { useNavigate } from 'react-router-dom';



export const handleDeleteMeetingClick = (item, setFailMessage, setOpenDeleteModal, setIdToDelete, isEditDisabled) => {
  if (!isEditDisabled) {
    setFailMessage("Are you sure you want to delete this meeting?");
    setOpenDeleteModal(true);
    setIdToDelete(item.mid);
  }
};

const CancelledMeetingCard = ({ item, commonStyles, handleOpenFullView, handleEdit, setFailMessage, setOpenDeleteModal, setIdToDelete, rbac , navigate}) => {

  

  const getBackgroundColor = (deptTag) => {
    switch (deptTag) {
      case 'HR':
        return '#1CA566';
      case 'IT':
        return '#4CB87C';
      case 'Governance':
        return '#057DAA';
      default:
        return '#FF9B00';
    }
  };

  let Email = Cuurent_EMAIL();


  if (!item) {
    return null; // Or render a placeholder, loading spinner, etc.
  }

  const deptTagColor = getBackgroundColor(item.deptartmentTagMaster?.deptTag);

  const { to, from, optional } = getEmailClassification(item?.emailDetail);


  const isUserAuthorized = item && item.emailDetail && from[0]?.participantEmail === Email;
  const isEditDisabled = rbac?.editAccess === "N" || !isUserAuthorized;

  return (
    <div style={{ ...commonStyles }} className="cancelled-meeting-card">
      <div style={{ backgroundColor: deptTagColor }} className="CancelM-card-circle"></div>
      <div>
        <div className="cancelm-meetsubject">{item.meetingSubject}</div>
        <div className="card-feild-container">
          <div className="heading-text">Date</div>
          <div className="date-start-t-end-time">
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <span style={{ color: "black" }}>:&nbsp;&nbsp;</span>
              <span style={{ color: 'black', paddingLeft: '5px' }}>{item.parseStartDate}&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div className="cancel-Time-key-val-cont">
              <span style={{color:'#999999'}}>Time</span>
              <span style={{ padding: '0px 20px' }}>:</span>
              <span>{item.startTime} - {item.endTime === "11:59 PM" ? "12:00 AM" : item.endTime}</span>
            </div>
          </div>
        </div>
        <div className="card-feild-container">
          <div className="heading-text">Cancelled By</div>
          <div style={{ fontSize: 13, color: "black" }}>
            :&nbsp;&nbsp;&nbsp;<span style={{ color: "black", paddingLeft: '3px' }}>{item.cancelledByName}</span>
          </div>
        </div>
        <div className="card-feild-container">
          <div className="heading-text">Reason</div>
          <div className="cancel-reason" style={{ fontSize: 13, color: '#999999' }}>
            <span style={{ fontSize: 13, color: "black" }}>:&nbsp;&nbsp;</span>
            <span style={{ fontWeight: 600, fontSize: 13, color: 'black', paddingLeft: "6px" }}>{item.cancelReason}</span>
          </div>
        </div>
      </div>
      <div className="icons-container">
        <div className="card-icons-div" data-testid="cancel-meeting-card-view-btn" id="normal" onClick={() => handleOpenFullView(item)}>
          <BsEye fill="#00AFF1" />
        </div>
        <div data-testid="cancel-meeting-card-edit-btn"
          className={isEditDisabled ? "disabled" : "card-icons-div"}
          id={isEditDisabled ? "disabled" : "normal"}
          onClick={() => !isEditDisabled && handleEdit(item.mid, navigate)}
        >
          <MdSchedule fill="#00AFF1" size={17} />
        </div>
        <div data-testid="cancel-meeting-card-del-btn"
          className={isEditDisabled ? "disabled" : "card-icons-div"}
          id={isEditDisabled ? "disabled" : "normal"}
          onClick={() => handleDeleteMeetingClick(item, setFailMessage, setOpenDeleteModal, setIdToDelete, isEditDisabled)}
        >
          <AiOutlineDelete fill="#00AFF1" />
        </div>
      </div>
      <div className="cancelM-border-div" style={{ backgroundColor: deptTagColor }}></div>
    </div>
  );
};

export default CancelledMeetingCard;
